export const MODE = import.meta.env.MODE;
export const BASE_API_URL = import.meta.env.VITE_BASE_API_URL;
export const BASE_LIB_URL = import.meta.env.VITE_BASE_LIB_URL;
export const BASE_API_PREFIX = import.meta.env.VITE_BASE_API_PREFIX;
export const ACCESS_PAYLOAD_KEY = "x-access-payload";
export const REFRESH_PAYLOAD_KEY = "x-refresh-payload";
export const BREAKPOINTS = { xs: 0, sm: 640, md: 768, lg: 1024, xl: 1280, "2xl": 1536 };
export const REFERENCE_DELIMITER = "<!--REFERENCE MESSAGE DELIMITER-->";
